import styled from 'styled-components';

export const CollapseContainer = styled.div`
  max-height: ${({ isOpen }) => (isOpen ? '100vh' : '0')};
  overflow: hidden;
  transition: max-height 0.25s ease-in-out;
  margin: ${({ isOpen }) => (isOpen ? '16px 0' : '0')}; ;
`;
